function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DEFAULT_TIMEOUT = 1000;
export var Timeout = /*#__PURE__*/function () {
  function Timeout(delayedAction) {
    var timeoutInMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMEOUT;
    _classCallCheck(this, Timeout);
    this.pending = false;
    if (typeof delayedAction !== 'function') {
      return;
    }
    this.timeoutInMs = timeoutInMs;
    this.reset(delayedAction);
  }
  return _createClass(Timeout, [{
    key: "cancel",
    value: function cancel() {
      clearTimeout(this.id);
      this.pending = false;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.action;
      if (this.pending) {
        clearTimeout(this.id);
      }
      if (typeof action !== 'function') {
        return;
      }
      if (action !== this.action) {
        this.action = function () {
          action();
          _this.pending = false;
        };
      }
      this.id = setTimeout(this.action, this.timeoutInMs);
      this.pending = true;
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.pending;
    }
  }]);
}();